import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { useDispatch, useSelector } from "react-redux";
import { getExams } from "store/services/exam.service";
import { GET_EXAMS, GET_PATIENTS, GET_MONTH_PATIENTS } from "store/types";
import { getPatients, getMonthPatients } from "store/services/patient.service";
import { GetExpenses } from "store/services/expenses.service";
import { getDoctors } from "store/services/doctor.service";
import { GET_DOCTORS, GET_EXPENSES } from "store/types";

const App = () => {
  const isLogin = window.sessionStorage.getItem("jwt");
  const auth = useSelector((state) => state.auth);
  if (auth.isLogin) {
    window.location.reload();
  }
  const dispatch = useDispatch();
  if (isLogin) {
    getExams().then((data) => {
      dispatch({ type: GET_EXAMS, payload: data });
    });
    getPatients().then((data) => {
      dispatch({ type: GET_PATIENTS, payload: data });
    });
    getMonthPatients().then((data) => {
      dispatch({ type: GET_MONTH_PATIENTS, payload: data });
    });
    GetExpenses().then((data) => {
      dispatch({ type: GET_EXPENSES, payload: data });
    });
    getDoctors().then((data) => {
      dispatch({ type: GET_DOCTORS, payload: data });
    });
  }

  return (
    <BrowserRouter>
      <Switch>
        {isLogin ? (
          <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        ) : (
          <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        )}
        {isLogin ? (
          <Redirect to={"/admin/tables"} />
        ) : (
          <Redirect to={"/auth"} />
        )}
      </Switch>
    </BrowserRouter>
  );
};

export default App;
